import CustomRangeSelector from './CustomRangeSelector';

export default CustomRangeSelector;
